import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "Epostadress", -1)
const _hoisted_4 = { class: "text-danger small p-0 m-0" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-label"
}, "Lösenord", -1)
const _hoisted_7 = { class: "text-danger small p-0 m-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary btn-sm"
}, "Logga in", -1)
const _hoisted_9 = { class: "text-danger mt-3" }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isAuthed)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          novalidate: "",
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "form-control form-control-sm",
              id: "email",
              "aria-describedby": "emailHelp",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.form.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.form.email]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.formErrors.email, (e, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(e), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control form-control-sm",
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.form.password) = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.form.password]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.formErrors.password, (e, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(e), 1)
              ]))
            }), 128))
          ]),
          _hoisted_8
        ], 32))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.error), 1),
    (_ctx.isAuthed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, " Logga ut ")
        ]))
      : _createCommentVNode("", true)
  ]))
}